var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"mr-2",attrs:{"color":"error","outlined":"","x-small":"","dark":""}},[_vm._v(_vm._s(_vm.$t('cancelled')))])
}
var staticRenderFns = []

export { render, staticRenderFns }